/**
 * Crocombe create a masked selector in DiskDriveType.groovy that has more options
 * the the UI supports.  Basically users will ALWAYS get their photos
 * plus they will get their source videos, clips or SV+CCE
 * So of the 2^4 options , really there are only 3
 */
const HAS_VIDEO = (1 << 0);
const HAS_FILM = (1 << 1);
const HAS_PHOTO  = (1 << 2);
const HAS_DIGITAL = (1 << 3);
// export const PHOTO_AND_FILM_AND_VIDEO = "PHOTO_AND_FILM_AND_VIDEO";
// export const DIGITAL_AND_PHOTO_AND_FILM = "DIGITAL_AND_PHOTO_AND_FILM";
//export const EVERYTHING = "EVERYTHING";
export const SOURCE_TYPE_CLIPS = "CLIPS";
export const SOURCE_TYPE_LONG_FORM = "LONG_FORM";
export const SOURCE_TYPE_ALL = "ALL";

export const usbActionTypes = {
    USBS_REQUESTED: 'USBS_REQUESTED',
    USBS_RECEIVED: 'USBS_RECEIVED',
    USBS_RECEIVED_FOR_SELECT: 'USBS_RECEIVED_FOR_SELECT',
    USBS_REQUEST_FAILED: 'USBS_REQUEST_FAILED',
    CLEAR_USB_PACKAGES: 'CLEAR_USB_PACKAGES',

    CREATE_USB_REQUEST: 'CREATE_USB_REQUEST',
    CREATE_USB_SUCCESS: 'CREATE_USB_SUCCESS',
    CREATE_USB_FAILED: 'CREATE_USB_FAILED',

    ADD_VIDEOS_TO_USB_REQUEST: 'ADD_VIDEOS_TO_USB_REQUEST',
    ADD_VIDEOS_TO_USB_SUCCESS: 'ADD_VIDEOS_TO_USB_SUCCESS',
    ADD_VIDEOS_TO_USB_FAILURE: 'ADD_VIDEOS_TO_USB_FAILURE',

    ADD_PHOTOS_TO_USB_REQUEST: 'ADD_PHOTOS_TO_USB_REQUEST',
    ADD_PHOTOS_TO_USB_SUCCESS: 'ADD_PHOTOS_TO_USB_SUCCESS',
    ADD_PHOTOS_TO_USB_FAILURE: 'ADD_PHOTOS_TO_USB_FAILURE',

    ADD_COLLECTION_TO_USB_REQUEST: 'ADD_COLLECTION_TO_USB_REQUEST',
    ADD_COLLECTION_TO_USB_SUCCESS: 'ADD_COLLECTION_TO_USB_SUCCESS',
    ADD_COLLECTION_TO_USB_FAILURE: 'ADD_COLLECTION_TO_USB_FAILURE',

    DELETE_USB_SUCCESS: "DELETE_USB_SUCCESS",
    DELETE_USB_FAILED: "DELETE_USB_FAILED",

    DELETE_USB_DESCRIPTOR_SUCCESS: "DELETE_USB_DESCRIPTOR_SUCCESS",
    DELETE_USB_DESCRIPTOR_FAILED: "DELETE_USB_DESCRIPTOR_FAILED",

    FINALIZE_USB_REQUEST: "FINALIZE_USB",
    FINALIZE_USB_SUCCESS: "FINALIZE_USB_SUCCESS",
    FINALIZE_USB_FAILED: "FINALIZE_USB_FAILED",

    ADD_ALBUM_TO_USB: "ADD_ALBUM_TO_USB",
    ADD_ELEMENT_TO_USB: "ADD_ELEMENT_TO_USB",
    ADD_TO_USB_SUCCESS: "ADD_TO_USB_SUCCESS",
    ADD_TO_USB_FAILED: "ADD_TO_USB_FAILED",
    ADD_TO_USB_REQUEST: "ADD_TO_USB_REQUEST",
    ADD_USB_TO_USB_SUCCESS: "ADD_USB_TO_USB_SUCCESS",

    FETCH_USB_REQUEST:"FETCH_USB_REQUEST",
    FETCH_USB_SUCCESS:"FETCH_USB_SUCCESS",
    FETCH_USB_FAILED:"FETCH_USB_FAILED",
    CLEAR_USB_ITEMS: "CLEAR_USB_ITEMS",

    CLEAR_SELECTED_USB_ITEMS:"CLEAR_SELECTED_USB_ITEMS",
    SELECT_USB_ITEM:"SELECT_USB_ITEM",
    DESELECT_USB_ITEM:"DESELECT_USB_ITEM",
    ENABLE_USB_ITEM_SELECTION_MODE:"ENABLE_USB_ITEM_SELECTION_MODE",
    DISABLE_USB_ITEM_SELECTION_MODE:"DISABLE_USB_ITEM_SELECTION_MODE",

    DELETE_SELECTED_ITEMS_REQUESTED:"DELETE_SELECTED_ITEMS_REQUESTED",
    DELETE_SELECTED_ITEMS_SUCCESS:"DELETE_SELECTED_ITEMS_SUCCESS",
    DELETE_SELECTED_ITEMS_FAILED:"DELETE_SELECTED_ITEMS_FAILED",

    UPDATE_CHAPTER_FAILED:"UPDATE_CHAPTER_FAILED",
    UPDATE_CHAPTER_SUCCESS:"UPDATE_CHAPTER_SUCCESS",
    UPDATE_CHAPTER_REQUESTED:"UPDATE_CHAPTER_REQUESTED",

    ENABLE_USB_ITEM_ARRANGE_MODE:"ENABLE_USB_ITEM_ARRANGE_MODE",
    DISABLE_USB_ITEM_ARRANGE_MODE:"DISABLE_USB_ITEM_ARRANGE_MODE",
    SET_USB_ITEM_SORT:"SET_USB_ITEM_SORT",
    SAVE_USB_ARRANGEMENT:"SAVE_USB_ARRANGEMENT",
    MOVE_USB_ITEM_AFTER:"MOVE_USB_ITEM_AFTER",
    SAVE_USB_ARRANGEMENT_SUCCESS:"SAVE_USB_ARRANGEMENT_SUCCESS",
    SAVE_USB_ARRANGEMENT_FAILED:"SAVE_USB_ARRANGEMENT_FAILED",
    USB_WIZARD_SET:"USB_WIZARD_SET",
    USB_WIZARD_SELECT_MEDIA:"USB_WIZARD_SELECT_MEDIA",
    USB_WIZARD_SAVE_FAILED:"USB_WIZARD_SAVE_FAILED",
    USB_WIZARD_SAVE_SUCCESS:"USB_WIZARD_SAVE_SUCCESS",
    USB_WIZARD_SAVE_START:"USB_WIZARD_SAVE_START",
    USB_WIZARD_DATA_RECEIVED:"USB_WIZARD_DATA_RECEIVED",
    USB_WIZARD_DATA_REQUESTED:"USB_WIZARD_DATA_REQUESTED",
    USB_WIZARD_SET_ROLLBACK_POINT:"USB_WIZARD_SET_ROLLBACK_POINT",
    USB_WIZARD_ROLLBACK:"USB_WIZARD_ROLLBACK",
    USB_WIZARD_ROLLBACK_SAVED:"USB_WIZARD_ROLLBACK_SAVED",

    USB_ITEM_ROTATE_REQUEST:'USB_ITEM_ROTATE_REQUEST',
    USB_ITEM_ROTATE_SUCCESS:'USB_ITEM_ROTATE_SUCCESS',
    USB_ITEM_ROTATE_ERROR:'USB_ITEM_ROTATE_ERROR',
    USB_SCROLL:'USB_SCROLL',
    USB_ITEM_SCROLL:'USB_ITEM_SCROLL'



};


// WEBPACK FOOTER //
// ./src/disc/actions/usb-action-types.js